import { convertArray, templateParseToElement } from "@bonusmap/shared_ui/library";
import { DataBaseComponent } from "./data-base-component";
import { BonusEroganti } from "../bonus-eroganti/bonus-eroganti";

export class DataErogantiComponent extends DataBaseComponent {
    static webComponentName: string = "data-eroganti";
    protected _templateId: string = "data-eroganti-component"; // Template ID for rendering
    protected inputType: string = "text"; // Default input type for categories fields
    protected erogantiComponent: BonusEroganti | null = null; // Reference to the categories input component
    protected rendered: boolean = false
    get value(): any {
        let outputValue= super.value;
        if (this.erogantiComponent && this.rendered) {
            
            outputValue = this.erogantiComponent.value;
        }
        if( Array.isArray(outputValue)) {
            outputValue = convertArray(outputValue, 'number');
        }
        return outputValue;
    }
    set value(newValue: any) {
        super.value = newValue;
    }
    constructor() {
        super();
    }
    addDataForTemplate(): Record<string, any> {
        const initialValue = Array.isArray(this.value) ? this.value.join(', ') : '';

        return {
            inputType: this.inputType, // Pass the input type to the template
            field: this.field, // Include field metadata
            readonly: this.readOnly, // Pass readOnly state
            initialValue
        };
    }
    protected afterRender(): void {
        super.afterRender();
        this.erogantiComponent = this.querySelector<BonusEroganti>('bonus-eroganti');
        if (this.erogantiComponent) {
            this.rendered = true;
        }
    }
    protected render(): void {
        templateParseToElement(this.templateId, this, this.addDataForTemplate());
        this.afterRender();
    }
}